import React, { useState } from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import rice from '../../../../images/raw_material/rice.png';
import DatePicker from "react-multi-date-picker";

const Consumption = ({ show, onClose }) => {
    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
    const options_units = [
        { value: "1", label: "gms" },
        { value: "2", label: "Kg's" },
        { value: "3", label: "Ltr's" },
        { value: "4", label: "ton's" },
    ]

    const [selectedOption, setSelectedOption] = useState(null);


    return (
        <Modal show={show} size="lg"  >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Consumption</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row mb-3">
                        <div className='col-lg-2'>
                            <div className="d-flex align-items-center">
                                <LightGallery
                                    onInit={onInit}
                                    speed={500}
                                    plugins={[lgThumbnail, lgZoom]}
                                >
                                    <div data-src={rice} className=''>
                                        <img src={rice} alt="Rice" className='w-100px h-120px' />
                                    </div>
                                </LightGallery>
                            </div>
                        </div>
                        <div className='col-lg-10'>
                            <div className='row'>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Raw Material</label>
                                    <label className='text-black fs-6 font-w500'>Basmathi Rice</label>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Category</label>
                                    <label className='text-black fs-6 font-w500'>
                                        <span>Grains</span>
                                        {/* <span className='me-2 ms-1'>/</span>
                                        <span>Rice</span> */}
                                    </label>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Current Stock</label>
                                    <label className='text-black fs-6 font-w500'>10 Kilogram</label>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Expiry Period</label>
                                    <label className='text-black fs-6 font-w500'>
                                        <Badge bg="info" className='text-white fs-7 py-0 px-1'>120 Days</Badge>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <label className="text-black font-w500 fs-5 mb-3">Needed Quantity</label>
                    <div className='row mb-3'>
                        <div className="col-lg-4 mb-2">
                            <label className="text-black font-w500 fs-7">Date<span className="required">*</span></label>
                            <div className='datepicker-wrapper d-flex'>
                                <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                <DatePicker placeholder='Select Date'
                                    value={selectedOption}
                                    format="DD-MM-YYYY"
                                />
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <label className="text-black font-w500 fs-7">Quantity<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Quantity" />
                        </div>
                        <div className='col-lg-4'>
                            <label className="text-black font-w500 fs-7">Units<span className="required">*</span></label>
                            <Select
                                defaultValue={options_units[1]}
                                onChange={setSelectedOption}
                                options={options_units}
                            />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4 pt-2">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={onClose}>Consumption  <i className="fas fa-angle-double-right ms-2"></i></Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Consumption;
